import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Motorcyles from "../components/Motorcycles";

const MotorcyclePage = () => {
  return (
    <div>
      <Navbar />
      <Motorcyles />
      <Footer />
    </div>
  );
};

export default MotorcyclePage;
